export enum NotificationFilters {
    CaseCreated = 'Case Created',
    CaseOwnerAssignment = 'Case Owner Assignment',
    NextActionExpired = 'Next Action Expired',
    NextActionDue = 'Next Action Due',
    AppsEngagementRequested = 'Apps Engagement Requested',
    CaseClosure = 'Case Closure',
    ProductCompanyEngagementRequested = 'Product Company Engagement Requested',
    CaseEscalated = 'Case Escalated',
    CaseSeverityS1 = 'Case Severity S1',
    NextActionAssigned = 'Next Action Assigned',
    InitialCaseContactAssigned = 'Initial Case Contact Assigned',
    StcEngagementRequested = 'Stc Engagement Requested',
    CaseUpdatedByNonOwner = 'Case Updated By Non-Owner',
    NewCommentAddedCase = 'New Comment Added Case',
    NextActionStatusChanged = 'Next Action Status Changed',
    CaseUpdatedByOwner = 'Case Updated By Owner'
  }